import PropTypes from "prop-types";
import React from "react";

const hasAnyChecked = (state = {}, data = [], hasFieldEntity = false) => {
    for(const i in data.fields) {
        const it = data.fields[i];
        if(hasFieldEntity) {
            if(state[it.entity].includes(it.key)) return true;
        }
        else {
            if(state[data.key].includes(it.key)) return true;
        }
    }
    return false;
};

const OptionGroupItem = ({state = {}, data = {}, onChange, expanded = false, hasFieldEntity = false}) => {
    const anyChecked = hasAnyChecked(state, data, hasFieldEntity);
    const [expand, setExpand] = React.useState(expanded);
    const handleExpand = () => {
        setExpand(!expand);
    };
    const handleChange = (key, stateKey) => {
        let v;
        if(state[stateKey].includes(key)) {
            v = state[stateKey].filter(it => it !== key);
        }
        else {
            v = [...state[stateKey], key];
        }
        onChange({...state,[stateKey]: v});
    };
    const handleGroupToggle = (e) => {
        e.stopPropagation();
        if(hasFieldEntity) {
            const v = {...state};
            data.fields.forEach(it => {
                if(anyChecked) {
                    // remove
                    if(v[it.entity].includes(it.key)) {
                        v[it.entity] = v[it.entity].filter(key => key !== it.key);
                    }
                }
                else {
                    // check
                    v[it.entity].push(it.key);
                }
            });
            onChange(v);
        }
        else {
            onChange({
                ...state,
                [data.key]: anyChecked ? [] : data.fields.map(it => it.key)
            });
        }
    };
    return (
        <React.Fragment>
            <div className={`entity group-title ${expand ? "" : "collapsed"}`} onClick={handleExpand}>
                <span>
                    <input
                        type="checkbox"
                        checked={anyChecked}
                        readOnly={true}
                        onClick={handleGroupToggle}
                    />
                    {" "}{data.name}
                </span>
            </div>
            <div className={`collapse group-items ${expand ? "in" : ""}`} id={data.key}>
                {data.fields.map((f) => {
                    const stateKey = hasFieldEntity ? f.entity : data.key;
                    return (
                        <label key={`${stateKey}.${f.key}`}>
                            <input type="checkbox"
                                   className="optionalField"
                                   checked={state[stateKey].includes(f.key)}
                                   onChange={() => handleChange(f.key, stateKey)}
                                   data-key={f.key}
                                   data-entity={data.key}
                            />
                            {" "}
                            <span>{f.name}</span>
                        </label>
                    );
                })}
            </div>
        </React.Fragment>
    );
};

OptionGroupItem.propTypes = {
    state: PropTypes.object,
    data: PropTypes.object,
    onChange: PropTypes.func,
    expanded: PropTypes.bool,
    hasFieldEntity: PropTypes.bool
};

const initializeState = (state, data, hasFieldEntity) => {
    // make sure state has all the fields
    const keys = {};
    if(hasFieldEntity) {
            data.forEach(it => {
            it.fields.forEach(f => {
                if (!keys[f.entity]) {
                    keys[f.entity] = [];
                }
            });
        });
    }
    else {
        data.forEach(it => {
            if (!keys[it.key]) {
                keys[it.key] = [];
            }
        });
    }
    return {
        ...keys,
        ...state
    };
};

const OptionGroup = ({title = "Fields to include in export:", state, data = [], onChange, expanded = false, hasFieldEntity = false}) => {
    state = initializeState(state, data, hasFieldEntity);
    const handleSelectAll = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const v = {};
        data.forEach(it => {
            if(hasFieldEntity) {
                it.fields.forEach(f => {
                    if(!v[f.entity]) {
                        v[f.entity] = [];
                    }
                    v[f.entity].push(f.key);
                });
            }
            else {
                v[it.key] = it.fields.map(f => f.key);
            }
        });
        onChange(v);

    };
    const handleSelectNone = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const v = {...state};
        Object.keys(state).forEach(key => {
            v[key] = [];
        });
        onChange(v);
    };
    return (
        <div className="form-section-inner">
            <h3>
                {title}{" "}
                <span className="header-links">
                    <a href="#" className="select-all" onClick={handleSelectAll}>Select All</a>
                    {" / "}
                    <a href="#" className="clear-all" onClick={handleSelectNone}>Clear All</a>
                </span>
            </h3>
            <div className="row">
                <div className="col-md-12">
                    <div className="optionHolder">
                        {data.map((it) => (
                            <OptionGroupItem
                                key={it.key + it.name}
                                state={state}
                                data={it}
                                expanded={expanded}
                                onChange={onChange}
                                hasFieldEntity={hasFieldEntity}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

OptionGroup.propTypes = {
    title: PropTypes.string,
    state: PropTypes.object,
    data: PropTypes.array,
    onChange: PropTypes.func,
    expanded: PropTypes.bool,
    hasFieldEntity: PropTypes.bool,
};

export default OptionGroup;



// WEBPACK FOOTER //
// ./app/lib/hex/views/components/OptionGroup.js